import { jsx } from "@emotion/react/jsx-runtime";
import { useTheme } from "@mui/material";
import { forwardRef } from "react";
const withThemeCondition = (AchieveComponent, MuiComponent) => forwardRef((props, ref) => {
  const theme = useTheme();
  const isMui = theme.useVanillaMui;
  const Component = isMui ? MuiComponent : AchieveComponent;
  return /* @__PURE__ */ jsx(Component, { ...props, ref });
});
export {
  withThemeCondition
};
//# sourceMappingURL=withThemeCondition.js.map
